import { nextArrow, prevArrow, options } from "@/global/slick-options";

jQuery( '.single-gallery-main' ).slick( {
    ...options,
    slidesToShow: 1,
    arrows: false,
    fade: true,
    asNavFor: '.single-gallery-nav'
} );

jQuery( '.single-gallery-nav' ).slick( {
    ...options,
    slidesToShow: 3,
    asNavFor: '.single-gallery-main',
    rows: 0,
    centerMode: true,
    centerPadding: '0',
    infinite: true,
} );


document.addEventListener("DOMContentLoaded", function() {
    const svgElement = document.getElementById("news-squiggly-line");
    if (svgElement) {
        svgElement.classList.remove("hidden");

        const paths = svgElement.querySelectorAll("path");
        paths.forEach(path => {
            const length = path.getTotalLength();
            path.style.strokeDasharray = length;
            path.style.strokeDashoffset = length;

            gsap.fromTo(path, { strokeDashoffset: length }, { duration: 2, strokeDashoffset: 0, ease: "power2.out" });
        });
    }
});
